import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '@/components/Breadcrumbs';
import { useOrganizationId } from '@/hooks/useSwr';
import { addQueryParams } from '@/utils/add-query-params';

export function PromptRepoCrumb(props: Partial<BreadcrumbData>) {
  const { repo } = useParams();
  const organizationId = useOrganizationId();
  if (!repo) return null;
  const innerPath =
    props.path === '#' ? '#' : addQueryParams(props.path, { organizationId });
  return <Breadcrumb {...props} name={repo} path={innerPath} />;
}
